import { useState, useEffect } from 'react'
import api from '../../../../utils/axiosInstance'
import { USE_MOCK } from '../../../../utils/mock/mockFlag'
import { mockSugestoes } from '../../../../utils/mock/mockData'
import { getApiBaseUrl } from '../../../../utils/defines/apiUrl'

export type Sugestao = {
    id: string
    titulo: string
    descricao: string
    severidade: 'critico' | 'atencao'
    grafico: string
    onlyId: string | null
    campo: string | null
}

export function useSugestoes(token: string) {
    const [sugestoes, setSugestoes] = useState<Sugestao[]>([])

    useEffect(() => {
        if (USE_MOCK) { setSugestoes(mockSugestoes.sugestoes); return }
        if (!token) return

        api.get(`${getApiBaseUrl()}/graficos/sugestoes?token=${encodeURIComponent(token)}`)
            .then(r => setSugestoes(r.data.sugestoes ?? []))
            .catch(() => setSugestoes([]))
    }, [token])

    return { sugestoes }
}
